<!-- <p>powerbi-widget works!</p> -->
 <ng-container *ngIf="title">
    <h5>{{title}}</h5>
 </ng-container>
<div #reportContainer  [style.height.px]="reportHeight?reportHeight:'500px'" style="width: 100%;" id="powerbi-report"></div>